<template>
    <div>
        <input type="checkbox" name="checkboxSidebar" id="checkboxSidebar" @click="checkbox = !checkbox" :checked="checkbox">
        <div class="sidebar">
            <div class="sidebar-superior">
                <p class="optum-bold">Menu</p>
                <label for="checkboxSidebar">
                    <b-icon-x class="icon-list" v-if="checkbox"/>
                    <b-icon-list class="icon-list" v-else/>                    
                </label>
            </div>        
            
            <ul class="sidebar-list">        
                <li v-for="(item, index) in itensPermitidos" :key="index" class="sidebar-item" :id="`link-${index}`">
                    <label v-if="item.sublinks" class="inside-sidebar-item" :for="`checkboxInsideSidebar-${index}`">
                        <input v-if="checkboxSublinks" type="checkbox" :name="`checkboxInsideSidebar-${index}`" 
                        :id="`checkboxInsideSidebar-${index}`" class="checkboxInsideSidebar"/>                   
                        
                        <div class="div-icon-sidebar-item">
                            <i class="bi" :class="item.class" 
                            :style="{ content :`url(${require(`@/assets/iconsSidebar/${item.icon}.svg`)})` }"></i>
                        </div>
                        <p>{{item.name}} <b-icon-chevron-up class="icon-chevron-up"/></p><br/>
                        
                        <ul class="ul-sublinks">
                            <li v-for="(link, index) in item.sublinks" :key="index">
                                <router-link :to="link.route" @click.native="checked">{{link.name}}</router-link>
                            </li>
                        </ul>

                        <b-popover :target="`link-${index}`" triggers="hover" placement="right" custom-class="popover-sidebar-item popover-sublinks menu"
                            :disabled.sync="disabledPopover" >
                                <ul > 
                                    <li v-for="(link, index) in item.sublinks" :key="index">
                                        <router-link :to="link.route" >{{link.name}}</router-link>
                                    </li>
                                </ul>
                        </b-popover>
                    </label>

                    <router-link :to="item.route" v-else class="inside-sidebar-item" @click.native="checked">
                        <div class="div-icon-sidebar-item">
                            <i class="bi" :class="item.class" 
                            :style="{ content :`url(${require(`@/assets/iconsSidebar/${item.icon}.svg`)})` }"></i>
                        </div>
                        <p>{{item.name}}</p>

                        <b-popover :target="`link-${index}`" triggers="hover" placement="right" custom-class="popover-sidebar-item"
                            :disabled.sync="disabledPopover">
                            <div>
                                {{item.name}}
                            </div>
                        </b-popover>
                    </router-link>         
                </li>
                <li class="sidebar-item d-flex align-items-center" id="sair" @click="logout">
                    <div class="div-icon-sidebar-item px-3 d-flex align-items-center h-100">
                        <i class="bi" :style="{ content :`url(${require(`@/assets/iconsSidebar/exit.svg`)})` }"></i>
                    </div>
                    <p class="sair">Sair</p>

                    <b-popover target="sair" triggers="hover" placement="right" custom-class="popover-sidebar-item"
                        :disabled.sync="disabledPopover">
                        <div> Sair </div>
                    </b-popover>
                </li>    
            </ul>            
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions} from "vuex"
import sidebarItensFactory from "./sidebar-itens"

export default {
    name: "Sidebar",
    data(){
        return {
            checkbox : true,
            disabledPopover: true
        }
    },
    computed: {
        ...mapGetters("user", ["authorities"]),
        itensPermitidos(){
            let itensPermitidos = [];
            let items = sidebarItensFactory()

            items.forEach( map => {
                if (map.sublinks) {
                    let arraySublinks = [];

                    map.sublinks.forEach( sublink => {
                        if (this.matchRole(sublink.authorities)) {
                            arraySublinks.push(sublink)
                        }
                    })
                    
                    map.sublinks = arraySublinks

                    if ( map.sublinks.length > 0 ) {
                        itensPermitidos.push(map)
                    }
                } 
                else {
                    if (this.matchRole(map.authorities)) {
                        itensPermitidos.push(map)
                    }
                }
            })

            return itensPermitidos
        },
        checkboxSublinks(){
            return this.checkbox == true ? true : false
        }
    },
    methods: {
        ...mapActions("user", ["clearLoggedUser"]),
        matchRole( link ) {
            if ( this.authorities ) {
                return link.some( ai => this.authorities.includes(ai) );
            }        

            return false
        },
        checked(){
            document.querySelector("#checkboxSidebar").checked = false
            this.checkbox = false
        },
        logout() {
            this.clearLoggedUser()
            .then(() => {
                this.$router.replace('/')
            })
        }
    },
    watch: {
        checkbox( value ){
            this.$emit("toggleCheckbox", value)
            this.disabledPopover = value == true ? true : false
        },
    }
}  
</script>

<style scoped lang="scss">
.sidebar{
    width: 60px;
    height: 100vh;
    background-color: #fff;
    transition: 0.3s;
    z-index: 1040;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    position: fixed;
}

#checkboxSidebar:checked ~ .sidebar{    
    width: 260px;
}

/* SUPERIOR */

.sidebar-superior{
    height: 55px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 40px;
    padding: 0px 15px;
    justify-content: space-between;    
}

html body .sidebar-superior p{
    font-size: 24px;
    transition: 0.5s;
    transition-delay: 0.5s;
    display: none;
    color: $primaryColor;
}

#checkboxSidebar{
    display: none;
}

#checkboxSidebar:checked ~ .sidebar .sidebar-superior p{
    display: flex;
}

.icon-list{
    cursor: pointer;
    font-size: 40px;
}

.icon-list:hover{
    background-color: #EFEFEE;
    border-radius: 5px;
}

.sidebar .bi{
    width: 25px;
    height: 24.667px;
}

/* INFERIOR */

ul, p{
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-item{    
    min-height: 45px;
    width: 100%;    
    display: flex;
    transition: 0.2s;
}

.sidebar-item:hover{
    background-color: $whiteColor;
}

.sidebar-item:hover .div-icon-sidebar-item{
    border-left: 5px solid #FF612B;
}

#checkboxSidebar:checked ~ .sidebar .sidebar-list .sidebar-item .inside-sidebar-item p,
#checkboxSidebar:checked ~ .sidebar .sidebar-list .sidebar-item p.sair{
    display: flex;
    transition: 0s;
    transition-delay: 0s;
}

.inside-sidebar-item{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
}

.div-icon-sidebar-item{
    cursor:pointer;
}

.checkboxInsideSidebar{
    display: none;
}

.checkboxInsideSidebar:checked ~ p .icon-chevron-up{
    transform: rotate(180deg);
}

.inside-sidebar-item div{
    height: 45px;
    padding: 0px 15px;
    display: flex;
    align-items: center;
    font-size: 25px;
    color: #f0a46d;
}

.inside-sidebar-item p, .sair{
    height: 45px;
    font-size: 16px;
    font-weight: 600;
    color: $tipographyColor;
    width: calc(100% - 60px);
    text-align: initial;
    display: none;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: 0.5s;
    transition-delay: 0.5s;
}

.icon-chevron-up{
    margin-right: 20px;
    transition: 0.2s;
}

.ul-sublinks{
    transition: 0.2s;
    padding-left: 20px;
    background-color:$whiteColor;  
    width: 100%;    
    overflow: hidden;    
    height: 0px;
    border-left: 5px solid #FF612B;
}

.checkboxInsideSidebar:checked ~ .div-icon-sidebar-item{
    border-left: 5px solid #FF612B;
    background-color: $whiteColor;
}

.checkboxInsideSidebar:checked ~ p { 
    background-color: $whiteColor;
}
.checkboxInsideSidebar:checked ~ .ul-sublinks{
    padding-top: 5px;
    padding-bottom: 5px;
    height: auto;
}

.ul-sublinks li a{
    font-size: 14px;
    color: $tipographyColor ;
}

.ul-sublinks li a:hover{
    cursor: pointer;
    color: #F2B411 !important;
}

.popover-sublinks{
    background-color: $whiteColor;
}

.popover-sublinks ul li a{
    font-size: 14px;
    color: $tipographyColor;
}

.popover-sublinks ul{
    padding: 0px 20px;
}

.popover-sublinks ul li a:hover{
    cursor: pointer;
    color: #F2B411 !important;
}

#sair{
    cursor: pointer
}

@media (max-width: 930px) {
    .sidebar{
        width: 100%;
        height: 60px;
        overflow: hidden;
    }
    
    .sidebar .sidebar-superior p{
        display: block;
    }

    #checkboxSidebar:checked ~ .sidebar{
        height: 100vh;
        width: 100%;
        position: absolute;
    }
    
    #checkboxSidebar:checked ~ .sidebar .sidebar-superior p{
        display: block;
    }

    #checkboxSidebar:checked ~ .sidebar .sidebar-list .sidebar-item .inside-sidebar-item p,
    #checkboxSidebar:checked ~ .sidebar .sidebar-list .sidebar-item p.sair{
        display: flex;
        opacity: 1;
    }

    .sidebar-superior{
        margin-bottom: 40px;
        justify-content: space-between;
    }

    .sidebar-superior label{
        margin-right: 10px;
    }
}

</style>

<style lang="scss">
    .popover-sublinks.menu .arrow::after{
        border-right-color: $whiteColor !important;
    }

    .popover-sidebar-item{
        padding: 5px 5px;
        font-size: 14px !important;
        font-weight: 600 !important;
        color: $tipographyColor !important;
    }

    @media (max-width: 930px) {
        .popover-sidebar-item{
            display: none;
        }
    }
</style>